import React from "react"
import PropTypes from "prop-types"

import id from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"
import {Tr} from "../../../ui/SimpleTable"

import {ParaNoMargin, Td} from "../../Wizard/Validate/ui/layout"


const FrequencyRenderer = ({schedule, ...props}) => {
  const idNamespace = id("FrequencyRenderer", props)
  const {periodValue} = schedule
  return (
    <Tr>
      <Td isLeft>
        <ParaNoMargin bold>
          <FormattedMessage id="insights.schedule.validate.frequency.label" />
        </ParaNoMargin>
      </Td>
      <Td>
        <ParaNoMargin id={idNamespace}> <FormattedMessage id={`insights.schedule.frequency.${periodValue}.label`} /> </ParaNoMargin>
      </Td>
    </Tr>
  )
}

FrequencyRenderer.propTypes = {
  schedule: PropTypes.object.isRequired
}

export default FrequencyRenderer
